import { DEFAULT_PRECISION } from 'helpers/constants';
import { baseToCustomUOM, getMeasurementUnits, getMeasurementUnitSymbol } from 'helpers/unitHelper';

export const handleUnitConversion = (response) => {
    const userMeasurementUnitGroups = getMeasurementUnits();
    response?.timeseries?.map((ts) => {
        const precision = ts?.timeseriesPrecision ?? ts?.precision ?? DEFAULT_PRECISION;
        const timeseriesUnitGroupID = ts?.timeseriesUnitGroupID;
        const unit = getMeasurementUnitSymbol(timeseriesUnitGroupID);
        const minValueObj = baseToCustomUOM?.convertAndFormatWithGroups(timeseriesUnitGroupID, ts?.minValue, userMeasurementUnitGroups);
        const maxValueObj = baseToCustomUOM?.convertAndFormatWithGroups(timeseriesUnitGroupID, ts?.maxValue, userMeasurementUnitGroups);
        const offsetObj = baseToCustomUOM?.convertAndFormatWithGroups(timeseriesUnitGroupID, ts?.offset, userMeasurementUnitGroups);
        ts.limits?.map((lmt) => {
            const valueObj = baseToCustomUOM?.convertAndFormatWithGroups(
                timeseriesUnitGroupID,
                lmt?.limitValue,
                userMeasurementUnitGroups);
            const limitPrecision = lmt?.precision ?? precision;
            lmt.limitValue = valueObj?.measurementValue % 1 === 0 ? valueObj?.measurementValue : valueObj?.measurementValue?.toFixed(limitPrecision);
        });
        ts.unit = unit;
        ts.minValue = minValueObj?.measurementValue % 1 === 0 ? minValueObj?.measurementValue : minValueObj?.measurementValue?.toFixed(precision);
        ts.maxValue = maxValueObj?.measurementValue % 1 === 0 ? maxValueObj?.measurementValue : maxValueObj?.measurementValue?.toFixed(precision);
        ts.offset = offsetObj?.measurementValue % 1 === 0 ? offsetObj?.measurementValue : offsetObj?.measurementValue?.toFixed(precision);
    });

    return response;
};
